import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { HeroSection } from "@/components/HeroSection";
import { ProblemSolutionSection } from "@/components/ProblemSolutionSection";
import { EcosystemSection } from "@/components/EcosystemSection";
import { PillarsSection } from "@/components/PillarsSection";
import { CasesSection } from "@/components/CasesSection";
import { ProcessSection } from "@/components/ProcessSection";
import { FAQSection } from "@/components/FAQSection";
import { FinalCTASection } from "@/components/FinalCTASection";
import { FloatingCTA } from "@/components/FloatingCTA";

const Index = () => {
  return (
    <div id="inicio" className="min-h-screen bg-[radial-gradient(circle_at_top,hsl(var(--primary)/0.14),transparent_55%),radial-gradient(circle_at_bottom,hsl(var(--primary)/0.08),transparent_45%)] bg-background">
      <Header />
      <main>
        <HeroSection />
        <ProblemSolutionSection />
        <EcosystemSection />
        <PillarsSection />
        <CasesSection />
        <ProcessSection />
        <FAQSection />
        <FinalCTASection />
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
};

export default Index;
